module.exports = __webpack_public_path__ + "static/media/left-chevron.059e3637.svg";